import React from 'react';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import MUILink from '@mui/material/Link';
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { breadcrumbsRoutes } from 'breadcrumbsRoutes';
import { SearchBreadcrumb } from 'ui';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  homeBreadcrumb: {
    color: 'inherit',
  },
  padded: {
    marginTop: theme.spacing(3),
  },
}));

const excludePaths = [
  '/announcements',
  '/credit-rating-coverage',
  '/esg-coverage',
  '/esg-coverage/:region/entities/',
  '/entities',
  '/entities/:entityId/instruments',
  '/entities/:entityId/announcements',
  '/instruments',
  '/search-result',
  '/search-result/:query',
  '/search-result/:query/:ratingType/entities',
  '/search-result/:query/:ratingType/entities/:entityId/instruments',
  '/search-result/:query/:ratingType/entities/:entityId/instruments/:instrumentId/announcements',
  '/search-result/:query/:ratingType/entities/:entityId/announcements',
  '/search-result/entities/:easyNumber/details',
  '/search-result/:query/:ratingType/instruments',
  '/search-result/:query/:ratingType/announcements',
  '/portfolios/:portfolioId/entities',
  '/portfolios/:portfolioId/entities/:entityId/instruments',
  '/portfolios/:portfolioId/entities/:entityId/instruments/:instrumentId/announcements',
  '/portfolios/:portfolioId/entities/:entityId/announcements',
  '/portfolios/:portfolioId/entities/:easyNumber/details',
  '/portfolios/:portfolioId/instruments',
  '/portfolios/:portfolioId/announcements',
  '/credit-rating-coverage/related/entities',
  '/credit-rating-coverage/related/entities/:entityId/instruments',
  '/credit-rating-coverage/related/entities/:entityId/instruments/:instrumentId/announcements',
  '/credit-rating-coverage/related/entities/:entityId/announcements',
  '/credit-rating-coverage/industry/entities',
  '/credit-rating-coverage/industry/entities/:entityId/instruments',
  '/credit-rating-coverage/industry/entities/:entityId/instruments/:instrumentId/announcements',
  '/credit-rating-coverage/industry/entities/:entityId/announcements',
  '/credit-rating-coverage/industry/announcements',
  '/credit-rating-coverage/:businessLine/entities',
  '/credit-rating-coverage/:businessLine/entities/:entityId/instruments',
  '/credit-rating-coverage/:businessLine/entities/:entityId/instruments/:instrumentId/announcements',
  '/credit-rating-coverage/:businessLine/entities/:entityId/announcements',
  '/covered-bonds',
  '/covered-bonds/:country/instruments',
];

const LinkRouter = (props) => <MUILink {...props} component={Link} />;

const Breadcrumbs = ({ separator }) => {
  const breadcrumbs = useBreadcrumbs(breadcrumbsRoutes, { excludePaths });
  const classes = useStyles();

  const isSearch = breadcrumbs.find(({ match }) => match.pathname.includes('search-result'));

  return (
    breadcrumbs.length > 1 && (
      <MUIBreadcrumbs
        aria-label="breadcrumb"
        className={clsx(classes.root, !isSearch && classes.padded)}
        separator={separator}
      >
        <a href={`${window.location.origin}/page-one`} className={classes.homeBreadcrumb}>
          {breadcrumbs[0].breadcrumb}
        </a>
        {isSearch ? <SearchBreadcrumb /> : null}
        {breadcrumbs.slice(1, breadcrumbs.length).map(({ match, breadcrumb }, index) => {
          const last = index === breadcrumbs.length - 2;

          return last ? (
            <Typography color="textPrimary" key={match.pathname}>
              {breadcrumb}
            </Typography>
          ) : (
            <LinkRouter color="inherit" to={match.pathname} key={match.pathname}>
              {breadcrumb}
            </LinkRouter>
          );
        })}
      </MUIBreadcrumbs>
    )
  );
};

export default Breadcrumbs;
